import gql from 'graphql-tag'

export const CATEGORIES = gql`
    query categories(
        $ids: [ID]
        $trashed: Trashed
    ){
        categories(
            ids: $ids
            trashed: $trashed
        ){
            id
            name
            description
            color
            is_project_category
            is_company_category
            deleted_at
        }
    }

`
export const CATEGORIESSEARCH = gql`
    query categoriesSearch(
        $searchText: String
    ){
        categoriesSearch(
            searchText: $searchText
        ){
            id
            name
            description
            color
            is_project_category
            is_company_category
            deleted_at
        }
    }

`

export const PROJECTCATEGORIES = gql`
    query projectCategories(
        $ids: [ID]
        $trashed: Trashed
    ){
        projectCategories(
            ids: $ids
            trashed: $trashed
        ){
            id
            name
            description
            color
            deleted_at
        }
    }

`
export const PROJECTCATEGORIESSEARCH = gql`
    query projectCategoriesSearch(
        $searchText: String
    ){
        projectCategoriesSearch(
            searchText: $searchText
        ){
            id
            name
            description
            color
            deleted_at
        }
    }

`
export const COMPANYCATEGORIES = gql`
    query companyCategories(
        $ids: [ID]
        $trashed: Trashed
    ){
        companyCategories(
            ids: $ids
            trashed: $trashed
        ){
            id
            name
            description
            color
            deleted_at
        }
    }

`
export const COMPANYCATEGORIESSEARCH = gql`
    query companyCategoriesSearch(
        $searchText: String
    ){
        companyCategoriesSearch(
            searchText: $searchText
        ){
            id
            name
            description
            color
            deleted_at
        }
    }

`